import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Service from "./pages/Service";
import AuthRedirect from "./pages/AuthRedirect";

import TalentDashboard from "./pages/TalentDashboard";
import PersonaCard from "./pages/PersonaCard";
import AIResume from "./pages/AIResume";
import MyMatches from "./pages/MyMatches";
import AIInterview from "./pages/AIInterview";
import InterviewChat from "./pages/InterviewChat";
import InterviewReport from "./pages/InterviewReport";
import Settings from "./pages/Settings";

import CompanyDashboard from "./pages/CompanyDashboard";
import CompanyCulture from "./pages/CompanyCulture";
import TeamMatch from "./pages/TeamMatch";
import CompanyInterviews from "./pages/CompanyInterviews";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/service" element={<Service />} />
          <Route path="/terms" element={<Service />} />
          <Route path="/auth/redirect" element={<AuthRedirect />} />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute requireOnboarded={false}>
                <Onboarding />
              </ProtectedRoute>
            }
          />

          {/* Talent app */}
          <Route path="/app" element={<ProtectedRoute role="talent"><TalentDashboard /></ProtectedRoute>} />
          <Route path="/app/persona" element={<ProtectedRoute role="talent"><PersonaCard /></ProtectedRoute>} />
          <Route path="/app/resume" element={<ProtectedRoute role="talent"><AIResume /></ProtectedRoute>} />
          <Route path="/app/matches" element={<ProtectedRoute role="talent"><MyMatches /></ProtectedRoute>} />
          <Route path="/app/interview" element={<ProtectedRoute role="talent"><AIInterview /></ProtectedRoute>} />
          <Route path="/app/interview/:id" element={<ProtectedRoute role="talent"><InterviewChat /></ProtectedRoute>} />
          <Route
            path="/app/interview/:id/report"
            element={
              <ProtectedRoute role="talent">
                <InterviewReport audience="talent" />
              </ProtectedRoute>
            }
          />
          <Route path="/app/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

          {/* Company app */}
          <Route path="/company" element={<ProtectedRoute role="company"><CompanyDashboard /></ProtectedRoute>} />
          <Route path="/company/culture" element={<ProtectedRoute role="company"><CompanyCulture /></ProtectedRoute>} />
          <Route path="/company/talent" element={<ProtectedRoute role="company"><TeamMatch /></ProtectedRoute>} />
          <Route path="/company/interview" element={<ProtectedRoute role="company"><CompanyInterviews /></ProtectedRoute>} />
          <Route
            path="/company/interview/:id/report"
            element={
              <ProtectedRoute role="company">
                <InterviewReport audience="company" />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
